// extracted by mini-css-extract-plugin
export default {"timeline-indicator":"cig94","completion-indicator":"ssCZC"};